import { render, staticRenderFns } from "./AccountSettingPassword.vue?vue&type=template&id=2ecce8f1&"
import script from "./AccountSettingPassword.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports